import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom'

function UploadItem (props) {

    function onCancel (ev) {
        ev.preventDefault();
        props.onCancel();
    }

    function onRetry (ev) {
        ev.preventDefault();
        props.onRetry();
    }

    function onClear (ev) {
        ev.preventDefault();
        props.onClear();
    }

    function closeIcon () {
        return <button type="button" className="close"
            onClick={onClear}
            aria-label="Close"
            disabled={props.status === 'inProgress'}
        >
            <span aria-hidden="true">&times;</span>
        </button>;
    }

    function progressElmt () {
        return props.status === 'inProgress' ?
            <ProgressBar now={props.progress} /> :
            null
        ;
    }

    var controls = {
        inProgress: <a onClick={onCancel} href="#">cancel</a>,
        complete: props.eventID ? null :
            <Link to="/manage/media">view asset</Link>,
        failed: <span className="status-message failed">Upload failed</span>,
        cancelled: <span className="status-message cancelled">Cancelled</span>
    };

    var name = props.eventID ?
        <span>{props.name} (event <Link to={'/events/?eventID=' + props.eventID}>{props.eventID}</Link>)</span> :
        props.name
    ;

    // left most icon / widget
    var icons = {
        inProgress: <div className="in-progress">
            {props.progress + '%'}
        </div>,
        failed: <i className="status-icon icon-failed fa fa-exclamation" aria-hidden="true"></i>,
        complete: <i className="status-icon icon-complete fa fa-check" aria-hidden="true"></i>
    };

    return (<li className="upload-item">
        <div className="row">
            <div className="upload-status col-xs-2">{icons[props.status]}</div>
            <div className="col-xs-6">
                <div className="upload-item-name">
                    {name}
                </div>
                {progressElmt()}
            </div>
            <div className="col-xs-4 text-right">
                {controls[props.status]}
                {closeIcon()}
            </div>
        </div>

    </li>);
}

export default UploadItem;
